import { Injectable } from '@angular/core';
import { HttpContext, HttpContextToken, HttpHeaders } from '@angular/common/http';

import { ServerRootDetector } from './server-root-detector';

export const HTTP_TOKEN_IGNORE_ERRORS = new HttpContextToken<boolean>(() => false);

@Injectable({
    providedIn: 'root',
})
export class ServerRootService {
    getAssetsRoot() {
        return ServerRootDetector.getInstance().getAssetsRoot();
    }

    getAuthRoot() {
        return ServerRootDetector.getInstance().getAuthRoot();
    }

    getBaseRoot() {
        return ServerRootDetector.getInstance().getBaseRoot();
    }

    getServerRoot() {
        return ServerRootDetector.getInstance().getResourceRoot();
    }

    getCustomPagesSiteRoot() {
        return ServerRootDetector.getInstance().getCustomPagesSiteRoot();
    }

    getTimelineSiteRoot () {
        return ServerRootDetector.getInstance().getTimelineSiteRoot();
    }

    buildOptions(auth: any = null, ignoreErrors = false) {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        // Inserisco le credenziali nell'header
        if (!!auth) {
            headers = headers.set('Authentication', 'credentials ' + this.encodeBase64(auth));
        }

        let context: HttpContext | undefined;
        if (ignoreErrors) {
            context ??= new HttpContext();
            context.set(HTTP_TOKEN_IGNORE_ERRORS, true);
        }

        return {
            context,
            headers: headers,
        };
    }

    protected encodeBase64(obj: any): string {
        if (!obj) {
            return;
        }

        return btoa(JSON.stringify(obj));
    }
}
